/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetSCCorrespondencesByExamID = require('../services/GetSCCorrespondencesByExamID');

var SecCorrespondenceView = require('../../common/views/SecCorrespondenceView');

module.exports = {
  channel: 'sc',

  event: 'build:exam-correspondence-grid-view',

  builder: function(examId) {
    return new PlaceholderView({
      viewPromise: buildExamCorrespondenceView(examId)
    });
  }
};

function buildExamCorrespondenceView(examId) {
  var deferred = $.Deferred();

  GetSCCorrespondencesByExamID(examId)
    .done(function(correspondences) {
      deferred.resolve(
        new SecCorrespondenceView({
          mode: 'exam',
          model: new Backbone.Model({
            examId: examId,
            correspondences: correspondences
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
